import { Inject, Injectable } from '@angular/core';
import { AreaSvgRegistrationService, IIcon } from '@caslink/common-client';
import * as cs from '../../legacy/legacy-services';
import { Observable } from 'rxjs';
import { LocationHttpService } from '../../location/services/location-http.service';

@Injectable({
    providedIn: 'root'
})
export class IconService {
    constructor(
        @Inject(cs.AreaSvgRegistrationService) private areaSvgRegistrationService: AreaSvgRegistrationService,
        private httpService: LocationHttpService,
    ) {
    }

    public getIcons(): Observable<IIcon[]> {
        return this.httpService.get<any>('content/icons/area/');
    }

    public tryRegisterSvgIcons() {
        if (!this.areaSvgRegistrationService.iconsLoaded) {
            this.getIcons().subscribe(icons => {
                this.areaSvgRegistrationService.registerMatIconObjects(icons);
            });
        }
    }
}
